import { columns } from './properties/columns'
import { sort } from './../properties/sort'
import { pagination } from './../properties/pagination'
import { model } from "./properties/model";
import { filter } from './properties/filter'
import { rules } from "./properties/rules";

export const state = {
    list: [],

    model: JSON.parse(JSON.stringify(model)),
    columns: columns,
    pagination: JSON.parse(JSON.stringify(pagination)),
    filter: filter,
    sort: JSON.parse(JSON.stringify(sort)),
    rules: rules
};
